// [2026-11-04] แถวที่เลื่อนซ้าย-ขวา (Top 10, แถวเกม, แถวหมวด) — scrollbar ถูกซ่อนไว้ทั้งเว็บ
//   มือถือปัดนิ้วได้อยู่แล้ว แต่คอม/เมาส์เลื่อนไม่ได้ → เพิ่ม:
//   1) ลากด้วยเมาส์ (drag) — ลากแล้วไม่นับเป็นการคลิก (กันเข้าเกมโดยไม่ตั้งใจ)
//   2) หมุนลูกกลิ้งเมาส์ = เลื่อนแนวนอน เฉพาะแถวที่ใส่ data-hscroll (แถวอื่นไม่ยุ่ง กันเลื่อนหน้าเว็บลงแล้วไปติดแถวเกม)
//      ถ้าเลื่อนสุดขอบแล้ว ปล่อยให้หน้าเว็บเลื่อนลงตามปกติ
//   3) แถวที่ใส่ data-hscroll="arrows" มีปุ่มลูกศร ‹ › ซ้าย-ขวา (เฉพาะจอที่ใช้เมาส์)

function isHScroller(el) {
  if (!el || el.nodeType !== 1) return false;
  if (el.scrollWidth <= el.clientWidth + 2) return false;
  const ox = getComputedStyle(el).overflowX;
  return ox === 'auto' || ox === 'scroll';
}
function findHScroller(node) {
  let el = node;
  for (let i = 0; el && el !== document.body && i < 12; i++, el = el.parentElement) {
    if (isHScroller(el)) return el;
  }
  return null;
}

let drag = null;
let suppressClickUntil = 0;

function onMouseDown(e) {
  if (e.button !== 0) return;
  const el = findHScroller(e.target);
  if (!el) return;
  drag = { el, x: e.clientX, left: el.scrollLeft, moved: false };
}
function onMouseMove(e) {
  if (!drag) return;
  const dx = e.clientX - drag.x;
  if (!drag.moved && Math.abs(dx) < 6) return;
  drag.moved = true;
  drag.el.scrollLeft = drag.left - dx;
  drag.el.style.cursor = 'grabbing';
  e.preventDefault();
}
function onMouseUp() {
  if (!drag) return;
  if (drag.moved) suppressClickUntil = Date.now() + 250;
  drag.el.style.cursor = '';
  drag = null;
}
function onClickCapture(e) {
  if (Date.now() < suppressClickUntil) { e.preventDefault(); e.stopPropagation(); }
}
function onDragStart(e) {
  if (findHScroller(e.target)) e.preventDefault(); // กันลากรูปออกมาแทนการเลื่อน
}
function onWheel(e) {
  if (e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // ทัชแพดเลื่อนแนวนอนเองได้อยู่แล้ว
  const el = findHScroller(e.target);
  if (!el || !el.hasAttribute('data-hscroll')) return;
  const max = el.scrollWidth - el.clientWidth;
  const d = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaY;
  if ((d < 0 && el.scrollLeft <= 0) || (d > 0 && el.scrollLeft >= max - 1)) return; // สุดขอบแล้ว ให้หน้าเว็บเลื่อน
  el.scrollLeft += d;
  e.preventDefault();
}

// ---------- ปุ่มลูกศร ----------
const ARROW_CSS = `
.hs-wrap{position:relative}
.hs-btn{position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:36px;height:36px;border-radius:50%;
  border:0;background:rgba(0,0,0,.55);color:#ffd34d;font-size:24px;line-height:34px;text-align:center;cursor:pointer;
  box-shadow:0 2px 8px rgba(0,0,0,.4);padding:0;opacity:.9}
.hs-btn:hover{opacity:1;background:rgba(0,0,0,.75)}
.hs-btn[hidden]{display:none}
.hs-prev{left:6px}.hs-next{right:6px}
@media (hover:none){.hs-btn{display:none}}
/* แถบเลื่อนของแถว data-hscroll ตั้งไว้ใน public/index.html (สีเดียวกับแถวเกมอื่น) */
`;
function addArrows(el) {
  if (el.__hsArrows) return;
  el.__hsArrows = true;
  const parent = el.parentElement;
  if (!parent) return;
  if (getComputedStyle(parent).position === 'static') parent.classList.add('hs-wrap');
  const mk = (cls, txt, dir) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'hs-btn ' + cls; b.textContent = txt; b.setAttribute('aria-label', dir > 0 ? 'ถัดไป' : 'ก่อนหน้า');
    b.addEventListener('click', (ev) => {
      ev.preventDefault(); ev.stopPropagation();
      el.scrollBy({ left: dir * Math.max(200, el.clientWidth * 0.8), behavior: 'smooth' });
    });
    parent.appendChild(b);
    return b;
  };
  const prev = mk('hs-prev', '‹', -1);
  const next = mk('hs-next', '›', 1);
  const sync = () => {
    const visible = el.offsetParent !== null; // แถวถูกซ่อน (display:none) = ซ่อนปุ่มด้วย
    const max = el.scrollWidth - el.clientWidth;
    prev.hidden = !visible || el.scrollLeft <= 2;
    next.hidden = !visible || el.scrollLeft >= max - 2 || max <= 2;
    // ปุ่มต้องอยู่ระดับเดียวกับแถว (parent อาจสูงกว่าแถว)
    const top = el.offsetTop + el.offsetHeight / 2;
    prev.style.top = next.style.top = top + 'px';
  };
  el.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  el.__hsSync = sync;
  sync();
}
function scanArrows() {
  document.querySelectorAll('[data-hscroll="arrows"]').forEach((el) => {
    addArrows(el);
    if (el.__hsSync) el.__hsSync();
  });
}

export function initHScroll() {
  if (typeof window === 'undefined' || window.__hsInit) return;
  window.__hsInit = true;
  document.addEventListener('mousedown', onMouseDown, true);
  window.addEventListener('mousemove', onMouseMove, true);
  window.addEventListener('mouseup', onMouseUp, true);
  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('dragstart', onDragStart, true);
  document.addEventListener('wheel', onWheel, { passive: false, capture: true });
  const st = document.createElement('style'); st.textContent = ARROW_CSS; document.head.appendChild(st);
  // React render ทีหลัง / สลับหน้า → สแกนหาแถวที่ต้องมีลูกศรเป็นระยะสั้น ๆ (เบามาก)
  let t = null;
  const mo = new MutationObserver(() => { clearTimeout(t); t = setTimeout(scanArrows, 150); });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  scanArrows();
}
